import React, { FC } from "react";

import Content from "components/Content";
import Label from "components/Label";
import text from "constants/text";
import styles from "./styles.module.scss";
import { icons } from "./constants";

const GrowingOurVendorNetwork: FC = () => {
  const { title, subtitle, offerings } = text.vendors.network;

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label variant="h-centered" color="lightPrimary" className={styles.title}>
        {title}
      </Label>
      <Label
        variant="s-centered"
        color="lightPrimary"
        className={styles.subtitle}
      >
        {subtitle}
      </Label>
      <div className={styles.network}>
        <div className={styles.offerings}>
          {offerings.map(({ name, icon }) => {
            const Icon = icons[icon];

            return (
              <div className={styles.networkOffering}>
                <Icon className={styles.networkIcon} />
                <Label variant="s-centered" color="supplemental">
                  {name}
                </Label>
              </div>
            );
          })}
        </div>
      </div>
    </Content>
  );
};

export default GrowingOurVendorNetwork;
